/**
 * ActividadEvent — renderiza tipo 'actividad' (GEN-HU-028).
 * payload: { herramienta, texto, denegada? }
 * Lo que hace el agente mientras trabaja: una línea discreta (gris, pequeña)
 * que se queda en el hilo al terminar el turno. El texto ya viene en lenguaje de
 * negocio desde el kernel; aquí solo se elige el icono. GEN-HU-014: si el kernel
 * deniega la herramienta (`denegada`), la línea lleva ⛔ y no es un «haciendo…».
 * GEN-HU-017: `subagente` es el encargo del agente a otro del equipo («Encargando a
 * Jorge: …», 🤝); las herramientas que usa el subagente llegan con su nombre delante.
 * GEN-HU-032: `WebSearch` («Buscando en la web "…"», 🌐) y `WebFetch` («Leyendo https://…», 🔗);
 * si se deniegan, la línea «No permitido» sale con ⛔ como cualquier otra.
 */

const ICONOS = {
  buscar_documentos: '🔎',
  leer_documento:    '📄',
  mcp__saber__buscar_saber: '🔎',  // GEN-EKB-033: «Buscando conocimiento…» y «Conocimiento encontrado: …»
  mcp__saber_escritura__aprender: '✍️',  // GEN-EKB-027: «Jimmy está redactando…»
  mcp__saber_escritura__aprender_carpeta: '✍️',  // GEN-EKB-041: «Jimmy sigue aprendiendo la carpeta…»
  mcp__saber_escritura__enlazar_ikus: '🔗',  // GEN-EKB-043: «Revisando si los iKus aplican en otros KBs…»
  subagente:         '🤝',
  WebSearch:         '🌐',   // GEN-HU-032: buscar en la web
  WebFetch:          '🔗',   // GEN-HU-032: leer una página
}

export default function ActividadEvent({ payload }) {
  const { herramienta, texto, denegada, resultado } = payload ?? {}
  if (!texto) return null
  if (denegada) {
    return (
      <div className="event-actividad event-actividad--denegada">
        <span className="event-actividad__icono" aria-hidden="true">⛔</span>
        <span className="event-actividad__texto">{texto}</span>
      </div>
    )
  }
  return (
    <div className="event-actividad">
      <span className="event-actividad__icono" aria-hidden="true">{ICONOS[herramienta] ?? '⚙️'}</span>
      <span className="event-actividad__texto">{texto}{resultado ? '' : '…'}</span>
    </div>
  )
}
